import common from '@page/common/js/common';
import RenderProductPageContent from '@page/productPage/js/ProductPageContent';

mq.productConfig = {
  stickyListMenu: true,
  templateVersion: 1,
  hasWishList: true,
  sizeSelectorTypeDesktop: 'dropdown',
  imageBasePath: 'http://image.mercci22.tw',
  zoomboxData: 'JumboImage',
  moreJumboImage: '.product-photos__images',
  imageRenderType: 'sliceFirst',
  refreshDOMs: ['.product-size'],
};

RenderProductPageContent();
